import type { MutableRefObject } from "react";

import { useIsomorphicLayoutEffect } from "../useIsomorphicLayoutEffect/useIsomorphicLayoutEffect";

const useOutsideClick = <T extends HTMLElement>(
  ref: MutableRefObject<T>,
  onClick: (e: MouseEvent) => void
) => {
  const useLayoutEffect = useIsomorphicLayoutEffect();

  useLayoutEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref?.current && !ref.current.contains(e.target as Node)) {
        onClick(e);
      }
    };
    document.addEventListener("click", handleClick, { capture: true });

    return () => {
      document.removeEventListener("click", handleClick, { capture: true });
    };
  }, [onClick]);
};

export { useOutsideClick };
